import { timestamp } from "./reviewApi";

const interviewerRoles = new Set(["agent", "assistant", "interviewer"]);
const candidateRoles = new Set(["user", "candidate", "human"]);

// Use the same recorded turn boundaries as the chapter timestamps. Never take
// an analyzed summary or borrow text from the next question's answer.
export function chapterAnswerTexts(chapters, transcript) {
  const turns = [];
  let turn = null;
  let lastTime = -1;
  for (const row of (Array.isArray(transcript) ? transcript : []).slice(
    0,
    2000,
  )) {
    if (!row || typeof row !== "object") continue;
    let time = timestamp(row.time_start) ? Number(row.time_start) : null;
    if (time !== null && time < lastTime) time = null;
    if (time !== null) lastTime = time;
    const role =
      typeof row.role === "string" ? row.role.trim().toLowerCase() : "";
    if (interviewerRoles.has(role)) {
      turn = {
        questionStart: time,
        answerStart: null,
        chunks: [],
        invalid: false,
      };
      turns.push(turn);
    } else if (
      turn &&
      candidateRoles.has(role) &&
      typeof row.content === "string" &&
      row.content.trim()
    ) {
      if (!turn.chunks.length) turn.answerStart = time;
      if (time === null) turn.invalid = true;
      turn.chunks.push(row.content.trim());
    }
  }
  return chapters.map((chapter) => {
    if (!timestamp(chapter.questionStart) || !timestamp(chapter.answerStart))
      return null;
    const questionStart = Number(chapter.questionStart);
    const answerStart = Number(chapter.answerStart);
    if (
      answerStart < questionStart ||
      (timestamp(chapter.end) && Number(chapter.end) <= answerStart)
    )
      return null;
    const matches = turns.filter(
      (item) =>
        !item.invalid &&
        item.questionStart === questionStart &&
        item.answerStart === answerStart,
    );
    return matches.length === 1 && matches[0].chunks.length
      ? matches[0].chunks.join("\n\n")
      : null;
  });
}

export function chapterStart(chapter) {
  return timestamp(chapter.questionStart) &&
    Number(chapter.questionStart) <= Number(chapter.answerStart)
    ? Number(chapter.questionStart)
    : Number(chapter.answerStart);
}
